import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-53edfe3a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "crowdloan__title" }, "Crowdloan", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "crowdloan__label" }, "Ongoing", -1))
const _hoisted_3 = { class: "crowdloan__header" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "crowdloan__header-item" }, "Parachain", -1))
const _hoisted_5 = { class: "crowdloan__header-item" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "crowdloan__header-item" }, "Liquidity Tokens", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "crowdloan__header-item" }, "My contribution", -1))
const _hoisted_8 = {
  key: 0,
  class: "crowdloan__loading"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "crowdloan__label inner" }, "Completed", -1))
const _hoisted_10 = {
  key: 2,
  class: "crowdloan__loading"
}

import WhiteWrapper from "@/components/white-wrapper/index.vue";
import CrowdloanItem from "./components/crowdloan-item.vue";
import ButtonsBlock from "@/components/buttons-block/index.vue";
import SelectList from "@/components/select-list/index.vue";
import SpinnerAnimation from "@/icons/animation/spinner.vue";
import { computed, onMounted, ref, watch } from "vue";
import { getCrowdloanItems } from "@/utils/crowdloan";
import { accounts, apiPromise, nativeToken, selectedNetwork } from "@/stores";
import { CrowdloanInfo } from "@/types/crowdloan";
import { AccountSelectItem, SelectItem } from "@/types/select-list";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const ongoing = ref<Array<CrowdloanInfo>>([]);
const completed = ref<Array<CrowdloanInfo>>([]);
const selectedAccount = ref<AccountSelectItem>();
const isLoading = ref(false);

onMounted(async () => {
  if (accounts.value.length) {
    selectedAccount.value = selectAccountItems.value[0];
    loadCrowdloanData();
  }
});

watch([selectedNetwork], () => {
  loadCrowdloanData();
});

const loadCrowdloanData = async () => {
  if (!isLoading.value) {
    isLoading.value = true;
    const api = await apiPromise.value;
    const [active, ended] = await getCrowdloanItems(api);
    ongoing.value = active;
    completed.value = ended;
    isLoading.value = false;
  }
};

const selectAccountAction = (item: SelectItem): void => {
  selectedAccount.value = item as AccountSelectItem;
};

const selectAccountItems = computed<AccountSelectItem[]>(() => {
  return accounts.value.map(
    (item) =>
      ({
        id: item.id,
        name: item.name,
        image: item.image,
        address: item.address,
      } as AccountSelectItem)
  );
});

watch(
  selectAccountItems,
  () => {
    if (selectAccountItems.value.length) {
      selectedAccount.value = selectAccountItems.value[0];
    }
    loadCrowdloanData();
  },
  { deep: true }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(WhiteWrapper, { class: "crowdloan__wrap" }, {
    default: _withCtx(() => [
      _createVNode(ButtonsBlock, { "is-space": true }, {
        default: _withCtx(() => [
          _hoisted_1,
          _createVNode(SelectList, {
            select: selectedAccount.value,
            items: selectAccountItems.value,
            "is-list-image": true,
            "onUpdate:select": selectAccountAction
          }, null, 8, ["select", "items"])
        ]),
        _: 1
      }),
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, " Raised " + _toDisplayString(_unref(nativeToken).symbol.toLocaleUpperCase()), 1),
        _hoisted_6,
        _hoisted_7
      ]),
      (isLoading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createVNode(SpinnerAnimation)
          ]))
        : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(ongoing.value, (item, index) => {
            return (_openBlock(), _createBlock(CrowdloanItem, {
              key: index,
              item: item,
              address: selectedAccount.value?.address
            }, null, 8, ["item", "address"]))
          }), 128)),
      _hoisted_9,
      (isLoading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createVNode(SpinnerAnimation)
          ]))
        : (_openBlock(true), _createElementBlock(_Fragment, { key: 3 }, _renderList(completed.value, (item, index) => {
            return (_openBlock(), _createBlock(CrowdloanItem, {
              key: index,
              item: item,
              address: selectedAccount.value?.address
            }, null, 8, ["item", "address"]))
          }), 128))
    ]),
    _: 1
  }))
}
}

})